import { render, staticRenderFns } from "./onebox-inbox-citizen.vue?vue&type=template&id=78ae1695&"
import script from "./onebox-inbox-citizen.vue?vue&type=script&lang=js&"
export * from "./onebox-inbox-citizen.vue?vue&type=script&lang=js&"
import style0 from "./onebox-inbox-citizen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports